import React from 'react'
import ModalPopup from './Modal'
import thumbsUpGif from "../../assets/gifs/deleteSuccess.gif";
import { useNavigate } from 'react-router-dom';

const DeleteSuccessModal = ({   show, module,redirectPage,redirectUrl,onClose}) => {
    const navigate = useNavigate();
  return (
     <ModalPopup
      className="alert-box-popup"
      show={show}
      size="md"
      onHide={onClose}
    >
      <div className="text-center flex justify-center flex-col items-center gap-3 px-3">
        <h3>{module} Deleted</h3>
        <img src={thumbsUpGif} className="w-[120px]" alt="success" />
        <p className="text-card-body">{module} deleted successfully</p>
        <button
          className="bg-primary_main text-white px-4 py-2 rounded-lg"
          onClick={() => {onClose();navigate(redirectUrl)}}

        >
          Back to {redirectPage}
        </button>
      </div>
    </ModalPopup>
  )
}

export default DeleteSuccessModal